import { render } from "./ConfigArea.vue?vue&type=template&id=dec3f544"
import script from "./ConfigArea.vue?vue&type=script&lang=js"
export * from "./ConfigArea.vue?vue&type=script&lang=js"

import "./ConfigArea.vue?vue&type=style&index=0&id=dec3f544&lang=css"

import exportComponent from "/home/runner/work/night.nana7mi.link/night.nana7mi.link/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__